import React, { useState } from 'react';
import { Controller, useForm } from "react-hook-form";
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
// import Navbar from '../components/navbar/NavBar';
import Footer from '../components/Footer';
// import { BASE_URL, CHANGE_PASSWORD } from '../utils/ApplicationURL';
import { TextField, IconButton, InputAdornment, Typography, Button } from '@mui/material';
import CommonContainer from "../components/CommonContainer";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { BASE_URL, CHANGE_PASSWORD } from '../utills/ApplicationRouting';
import toast, { Toaster } from 'react-hot-toast';
// import DLoading from '../components/DLoading';
const ChangePassword = () => {
  const { handleSubmit, control, formState: { errors }, watch,getValues } = useForm();
  const navigate = useNavigate();
  const { tokenId } = useParams();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const onSubmit = (data) => {
    setIsLoading(true)
    const postData = {
      token: tokenId,
      password: data.password,
      confirmPassword: data.confirmPassword,
    };

   axios
  .post(`${BASE_URL}${CHANGE_PASSWORD}`, postData)
  .then((response) => {
    if (response.status === 200) {
      setIsLoading(false)
      toast.success("Password changed successfully!");

      setTimeout(() => {
        navigate("/login", { replace: true });
      }, 2000);
    }
  })
      .catch((error) => {
  setIsLoading(false)
  if (error.response && error.response.status !== 200) {
    setIsLoading(false)
    toast.error(error.response.data.message || "Something went wrong");
  }
});
  };

  const password = watch("password");

  return (
    <>
    <Toaster />
      {/* <Navbar /> */}
      {/* {isLoading && <DLoading />} */}
      <div className="w-full bg-gray-100">
  <CommonContainer>
    <div className="min-h-[80vh] flex items-center justify-center py-12">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
         <Typography
  variant="h6"
  component="span"
  align="center"
  className="block w-full font-bold"
>
  Change Password
</Typography>

<br />
          <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-4">
              <Controller
                name="password"
                control={control}
                defaultValue=""
                rules={{
                  required: 'Password is required',
                  minLength: { value: 8, message: 'Password must be at least 8 characters long' },
                  maxLength: { value: 120, message: 'Password cannot exceed 120 characters' },
                  pattern: {
                    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,120}$/,
                    message:
                      'Password must contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character',
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={
                      <span>
                        Password <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    type={showPassword ? 'text' : 'password'}
                    variant="outlined"
                    fullWidth
                    error={!!errors.password}
                    helperText={errors.password?.message}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowPassword(!showPassword)}>
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </div>

            <div className="mb-4">
              <Controller
                name="confirmPassword"
                control={control}
                defaultValue=""
                rules={{
                  required: 'Please confirm your password',
                  minLength: { value: 8, message: 'Password must be at least 8 characters long' },
                  maxLength: { value: 120, message: 'Password cannot exceed 120 characters' },
                  pattern: {
                    value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,120}$/,
                    message:
                      'Password must contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character',
                  },
                  validate: {
                    matchesPassword: (value) =>
                      value === getValues('password') || 'Passwords do not match',
                  },
                }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={
                      <span>
                        Confirm Password <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    type={showConfirmPassword ? 'text' : 'password'}
                    variant="outlined"
                    fullWidth
                    error={!!errors.confirmPassword}
                    helperText={errors.confirmPassword?.message}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </div>


           <Button
  type="submit"
  variant="contained"
  fullWidth
  sx={{
    backgroundColor: "#153E75",
    color: "#fff",
    textTransform: "uppercase",
    fontSize: "0.875rem",
    fontWeight: 600,
    py: 1,
    borderRadius: "6px",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  }}
>
  Change Password
</Button>

            {/* <div className="flex items-center justify-center mt-4">
  <Link to="/signup" className="text-blue-700 text-center text-sm block">
    Back to Sign In
  </Link>
</div> */}
          </form>
          <br />

<div className="text-gray-600 text-center" style={{ fontSize: "10px" }}>
  Please enter and confirm your new password to update your account securely.
</div>
        </div>
      </div>
       </CommonContainer>
</div>
      {/* <Footer /> */}
    </>
  );
};

export default ChangePassword;
